<template>
	<div class="modern-product-list-item pa-3 mb-2 d-flex align-center" @click="$emit('click:image', $event)">
		<!-- Thumbnail -->
		<div class="thumbnail-wrap mr-4">
			<v-img contain :src="product.image_url" height="64px" width="64px" class="thumbnail-img"></v-img>
		</div>

		<!-- Content -->
		<div class="flex-grow-1 pr-3">
			<div class="d-flex align-center flex-wrap mb-1">
				<span class="category-pill-sm mr-2" v-if="product.categoria">
					{{ product.categoria.nombre }}
				</span>
				<span
					class="featured-pill-sm mr-2 text-capitalize"
					v-if="product.destacado == '1' || product.destacado === true"
				>
					<v-icon x-small color="#f59e0b" class="mr-1">mdi-star</v-icon>
					{{ "starred" | trans }}
				</span>
				<span class="caption text-secondary-custom">
					{{ "store.reference" | trans }}: <strong class="text-slate-700">{{ product.referencia }}</strong>
				</span>
			</div>

			<h4 class="product-list-title mb-1 text-slate-800">{{ product.name }}</h4>

			<div class="d-flex align-center flex-wrap">
				<span v-if="product.mostrar_precio" class="product-list-price mr-3">
					{{ product | price | money }}
				</span>
				<span v-if="product.mostrar_stock" class="stock-pill-sm in-stock">
					{{ "store.stock" | trans }}: {{ product.stock | number }}
				</span>
				<span v-else-if="product.stock > 0" class="stock-pill-sm in-stock">
					{{ "store.stock_available" | trans }}
				</span>
			</div>
		</div>

		<!-- Actions -->
		<div class="list-action-wrap">
			<v-btn
				v-if="!product.advanced_stock || product.advanced_stock.length == 0"
				color="primary"
				depressed
				rounded
				small
				class="text-capitalize"
				@click.stop="addToCart"
			>
				<v-icon x-small left>mdi-cart-plus</v-icon>
				<span class="hidden-sm-and-down">{{ "store.add" | trans }}</span>
			</v-btn>
			<v-btn
				v-else
				color="primary"
				outlined
				rounded
				small
				class="text-capitalize"
				:to="`/product/${encodeURIComponent(product.referencia)}`"
				@click.stop
			>
				<v-icon x-small left>mdi-tune</v-icon>
				<span class="hidden-sm-and-down">{{ "options" | trans }}</span>
			</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProductList",
	props: ["product", "maxWidth"],
	data() {
		return {
			hover: false,
		};
	},
	methods: {
		addToCart() {
			this.api.cart.addToCart(this.product);
		},
	},
};
</script>

<style scoped>
.modern-product-list-item {
	background-color: #ffffff;
	border: 1px solid #eef2f6;
	border-radius: 12px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.modern-product-list-item:hover {
	border-color: #cbd5e1;
	box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);
	transform: translateY(-2px);
}

.thumbnail-wrap {
	background-color: #f8fafc;
	border-radius: 8px;
	border: 1px solid #f1f5f9;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-list-title {
	font-size: 0.95rem;
	font-weight: 600;
	color: #0f172a;
	line-height: 1.3;
}

.product-list-price {
	font-size: 1rem;
	font-weight: 700;
	color: #0f172a;
}

.category-pill-sm {
	font-size: 0.7rem;
	font-weight: 600;
	padding: 1px 6px;
	border-radius: 4px;
	background-color: #eff6ff;
	color: #2563eb;
}

.featured-pill-sm {
	display: inline-flex;
	align-items: center;
	font-size: 0.68rem;
	font-weight: 700;
	padding: 1px 6px;
	border-radius: 4px;
	background-color: #fffbeb;
	color: #b45309;
	border: 1px solid #fef3c7;
}

.stock-pill-sm {
	font-size: 0.7rem;
	font-weight: 600;
	padding: 1px 6px;
	border-radius: 4px;
	background-color: #f1f5f9;
	color: #475569;
}

.stock-pill-sm.in-stock {
	background-color: #ecfdf5;
	color: #059669;
}

.text-slate-800 {
	color: #1e293b;
}

.text-slate-700 {
	color: #334155;
}

.text-secondary-custom {
	color: #64748b;
}
</style>
